import React from "react"

const FileUploadContext = React.createContext(null)

export default FileUploadContext
